var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20H8C4.229 20 2.343 20 1.172 18.828C-1.19209e-07 17.657 0 15.771 0 12V8C0 4.229 -1.19209e-07 2.343 1.172 1.172C2.343 -1.19209e-07 4.239 0 8.03 0C8.636 0 9.121 -4.09782e-08 9.53 0.017C9.517 0.097 9.51 0.178 9.51 0.261L9.5 3.095C9.5 4.192 9.5 5.162 9.605 5.943C9.719 6.79 9.98 7.637 10.672 8.329C11.362 9.019 12.21 9.281 13.057 9.395C13.838 9.5 14.808 9.5 15.905 9.5H19.957C20 10.034 20 10.69 20 11.563V12C20 15.771 20 17.657 18.828 18.828C17.657 20 15.771 20 12 20Z",
    fill: "#FFDC7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51 0.259883L9.5 3.09488C9.5 4.19188 9.5 5.16088 9.605 5.94288C9.719 6.78988 9.98 7.63688 10.672 8.32788C11.362 9.01888 12.21 9.28088 13.057 9.39488C13.838 9.49988 14.808 9.49988 15.905 9.49988H19.957C19.97 9.65488 19.979 9.82088 19.985 9.99988H20C20 9.73188 20 9.59788 19.99 9.43988C19.913 8.48963 19.5821 7.57752 19.032 6.79888C18.938 6.67088 18.874 6.59488 18.747 6.44188C17.954 5.49388 16.91 4.31188 16 3.49988C15.19 2.77588 14.079 1.98488 13.11 1.33888C12.278 0.782883 11.862 0.504883 11.291 0.298883C11.1249 0.239447 10.956 0.188054 10.785 0.144883C10.401 0.0498827 10.027 0.0168828 9.5 0.00488281L9.51 0.259883Z",
    fill: "#FDBD19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.c6bb9bea3c23da5dcb3b94ea39a30ebc.svg";
export { ForwardRef as ReactComponent };